import { useMemo } from "react";
import { Layer } from "react-migration/layouts/map/Multilayer/types";
import { useLayerAccess } from "../../../useLayerAccess";
import { US_INSIGHT_SUMMARY_LAYERS, UK_INSIGHT_SUMMARY_LAYERS } from "./insightSummaryLayers";
import { keyBy } from "lodash";

function hasLayerSummary(layer: Layer) {
  return layer.layerType.LayerSummary != null;
}

export function useInsightSummaryLayers(isUSUser: boolean) {
  const summaryLayers = isUSUser ? US_INSIGHT_SUMMARY_LAYERS : UK_INSIGHT_SUMMARY_LAYERS;
  const [authorisedSummaryLayers, restrictedByFeature] = useLayerAccess(summaryLayers);

  const layers = useMemo(() => authorisedSummaryLayers.filter(hasLayerSummary), [authorisedSummaryLayers]);

  const disabledLayers = useMemo(() => restrictedByFeature.filter(hasLayerSummary), [restrictedByFeature]);

  const layerLookup = useMemo(() => keyBy(layers, (layer) => layer.id), [layers]);

  return [layers, layerLookup, disabledLayers] as const;
}
